import { Dashboardv99990101Api } from '@sequencehq/api/dashboard/v99990101'
import { IntegrationServices } from '@sequencehq/api/utils'

export type EntityTypeSyncToggle =
  Dashboardv99990101Api.GetEntityTypeSyncToggles.EntityTypeSyncToggle

/**
 * A live (not soft-deleted) toggle that governs pushing customers to an ERP.
 * This is the toggle behind the "auto-link customers" setting; both the
 * settings switch and the invoice warning key off it, so the matching rule
 * lives in one place.
 */
export const isLiveCustomerPushToggle = (
  toggle: EntityTypeSyncToggle
): boolean =>
  toggle.entityType === 'CUSTOMER' &&
  toggle.syncDirection === 'PUSH' &&
  !toggle.deletedAt

/**
 * Whether an unlinked customer will actually be auto-pushed: the toggle must be
 * a live customer-push toggle, enabled, and ALLOW once the backend has resolved
 * the permission across the global/integration/entity levels.
 */
export const willAutoLinkCustomers = (toggle: EntityTypeSyncToggle): boolean =>
  isLiveCustomerPushToggle(toggle) &&
  toggle.enabled &&
  toggle.syncPermission === 'ALLOW'

/**
 * Locates the live customer-push toggle for a service within a toggle list, or
 * null when none exists. The (service + customer-push) key is the natural key
 * behind the auto-link setting, so both the list-then-update and the
 * create-conflict recovery paths resolve the row through here.
 */
export const findLiveCustomerPushToggle = (
  toggles: EntityTypeSyncToggle[],
  service: IntegrationServices
): EntityTypeSyncToggle | null =>
  toggles.find(
    toggle =>
      toggle.integrationService === service && isLiveCustomerPushToggle(toggle)
  ) ?? null
